/* ==========================================================================
  main.js
========================================================================== */

/**
 * Navigation
 */
//aucor_navigation(document.getElementById('primary-navigation'), {
//  desktop_min_width: 501, // min width in pixels
//  menu_toggle: '#menu-toggle' // selector for toggle
//});

/**
 * Responsive videos
 */
fitvids();


// add jquery as dependency in functions.php and uncomment the following if you need jquery
//
(function ($) {
  $(document).ready(function () {

    //mobile navigation
    $('a.target-burger').click(function (e) {
      $('div.site-content, nav.main-nav, a.target-burger').toggleClass('toggled');
      e.preventDefault();
    });

    // desktop navigation

    var $navbar = $('.main-nav');

    var $offsetY = $navbar.offset().top + 300;

    function scroll() {
      if ($(window).width() > 1199) {
        if ($(window).scrollTop() >= $offsetY) {
          $navbar.addClass('menu-fixed');
        } else {
          $navbar.removeClass('menu-fixed');
        }
      }
    }

    document.onscroll = scroll;

    // mouse slide
    $('#mouse').on('click', function () {
      var targetMouse = $('#news');
      $('html, body').animate({
        scrollTop: targetMouse.offset().top - 50
      }, 1000);
    });


    // slider klienci

    $('.slider').bxSlider({
      pager: false,
      controls: false,
      speed: 20000,
      ticker: true,
      slideWidth: 400,
      minSlides: 1,
      maxSlides: 6
    });

    // slider eventy / drukarnia

    $('.event-slider').bxSlider({
      pager: false,
      controls: true,
      speed: 1000,
      touchEnabled: false
    });

    // matchHeight
    $('.height').matchHeight();

    var $grid = $('.portfolio_gallery').masonry({
      itemSelector: '.portfolio_gallery-item',
      percentPosition: true
    });

    // $grid.imagesLoaded().progress(function () {
    //   $grid.masonry();
    // });


  });
})(jQuery);

/**
 * Polyfill object-fit for lazyloaded
 */
if (typeof objectFitPolyfill === "function") {
  document.addEventListener('lazybeforeunveil', function (e) {

    // current <img> element
    var el = e.target;

    objectFitPolyfill();
    el.addEventListener('load', function () {
      objectFitPolyfill();
    });

  });
}
(function ($) {
  $(document).ready(function () {
    var macy = new Macy({
      container: '#macy-container',
      margin: 15,
      columns: 6,
      breakAt: {
        1200: 5,
        940: 3,
        520: 2,
        400: 1
      }
    });
  });

})(jQuery);
